// extracted by mini-css-extract-plugin
module.exports = {"callout_INF7ob":"callout_INF7ob","small_2gIeMj":"small_2gIeMj"};